/*
 * Copyright © 2024. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import {
  APPLICATION_STATUS_CONCERN_SUMMARY,
  APPLICATION_STATUS_CONTRACT_BASE,
  APPLICATION_STATUS_CONTRACT_CATEGORY,
  APPLICATION_STATUS_CONTRACT_DESCRIPTION,
  APPLICATION_STATUS_CONTRACT_DOCUMENTS,
  APPLICATION_STATUS_REFINEMENT,
  APPLICATION_STATUS_SUMMARY,
} from "@/src/services/contractLaw/applicationStatus";
import React from "react";
import ProgressBar from "@/src/components/ProgressBar/ProgressBar";
import progressBarsteps from "./progressBarSteps";
import contractLawFormSteps from "@/src/services/contractLaw/formSteps";
import ContractBase from "@/src/components/Form/ContractLaw/ContractBase";
import ContractDescription from "@/src/components/Form/ContractLaw/ContractDescription";
import { FormSteps } from "@/src/types/FormServiceBase";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import ContractLawCaseSelection from "@/src/components/Form/ContractLaw/ContractLawCaseSelection";
import { DocumentsForm } from "@/src/components/Form/DocumentsForm/DocumentsForm";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_CONTRACT_CATEGORY]: {
    title: "Antrag - Ihre Vertragsart | Legalbird",
    applicationStatus: APPLICATION_STATUS_CONTRACT_CATEGORY,
    stepUrl: "vertragsart",
    render: (props) => (
      <>
        <HintBox headline={"Wir kümmern uns um Ihre Vertragsangelegenheit!"}>
          <p>
            Bitte schildern Sie uns anhand der folgenden Fragen kurz Ihre Situation. Jede Information hilft uns dabei, Sie bestmöglich zu beraten und direkt
            rechtliche Schritte einleiten zu können. Sollten Sie bei Fragen unsicher sein, machen Sie sich hierüber keine Sorgen: Sie können zusätzlich den Fall
            noch frei aus Ihrer Sicht schildern.
          </p>
        </HintBox>
        <ProgressBar steps={progressBarsteps} active={"contract"} progress={25} />
        <ContractLawCaseSelection {...props} applicationStatus={APPLICATION_STATUS_CONTRACT_CATEGORY} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTRACT_BASE]: {
    ...contractLawFormSteps[APPLICATION_STATUS_CONTRACT_BASE],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"contract"} progress={25} />
        <ContractBase {...props} hideCaseCategories={true} alternativeHeadline="Ihre Angaben" />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTRACT_DESCRIPTION]: {
    ...contractLawFormSteps[APPLICATION_STATUS_CONTRACT_DESCRIPTION],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"contract"} progress={25} />
        <ContractDescription {...props} applicationStatus={contractLawFormSteps[APPLICATION_STATUS_CONTRACT_DESCRIPTION].applicationStatus} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTRACT_DOCUMENTS]: {
    ...contractLawFormSteps[APPLICATION_STATUS_CONTRACT_DOCUMENTS],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={75} />
        <DocumentsForm product={props.product} submitProps={props.submitProps} />
      </>
    ),
  },
  [APPLICATION_STATUS_REFINEMENT]: {
    ...contractLawFormSteps[APPLICATION_STATUS_REFINEMENT],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={75} />
        <DocumentsForm product={props.product} submitProps={props.submitProps} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONCERN_SUMMARY]: {
    ...contractLawFormSteps[APPLICATION_STATUS_CONCERN_SUMMARY],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={75} />
        <DocumentsForm product={props.product} submitProps={props.submitProps} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: contractLawFormSteps[APPLICATION_STATUS_SUMMARY],
};

export default formSteps;
